<template>
  <div id="organization">
    <div class="title">
      <img src="../../assets/image/icon_tj@2x.png" alt />
      <h3>统计</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 项目统计 -->
        <el-tab-pane label="项目统计" name="1">
          <div class="searchRow">
            <el-input class="tableSearch" v-model="searchInfo" placeholder="标题内容搜索"></el-input>
            <!-- <el-select clearable class="tableSearch" v-model="searchClass" placeholder="请选择搜索部门">
              <el-option
                v-for="item in classList"
                :key="item.department_id"
                :label="item.department_name"
                :value="item.department_id"
              ></el-option>
            </el-select>-->
            <el-cascader
              :modal-append-to-body="false"
              class="tableSearch"
              v-model="searchClassArr"
              filterable
              clearable
              @change="handleCasSearchChange"
              :options="selectClassList"
              :props="{ value:'department_id', label:'department_name', checkStrictly: true}"
              placeholder="请选择搜索部门"
            ></el-cascader>
            <one-selected @my-one-change="handleSearchPeopleChange"></one-selected>
            <div class="btnCol">
              <el-button class="search" @click="handleSearch">查询</el-button>
              <el-button class="out" @click="handleOutClick">导出</el-button>
              <!-- <el-button class="creat" style="background-color:#40A0F2;" @click="addUserClick">新建</el-button> -->
            </div>
          </div>
          <el-table
            :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
            :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
            :data="tableData"
            stripe
            height="calc(100% - 68px - 20px - 50px)"
            style="width: 100%; margin-top:20px"
          >
            <el-table-column
              prop="nickname"
              :show-overflow-tooltip="true"
              align="center"
              label="姓名"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="department_name"
              :show-overflow-tooltip="true"
              align="center"
              label="部门"
            ></el-table-column>
            <el-table-column
              prop="count1"
              :show-overflow-tooltip="true"
              align="center"
              label="选择时间段内完成的项目"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="count2"
              width="150"
              :show-overflow-tooltip="true"
              align="center"
              label="逾期项目"
            ></el-table-column>
            <el-table-column
              prop="count3"
              :show-overflow-tooltip="true"
              align="center"
              width="200"
              label="正在进行的项目"
            ></el-table-column>
            <el-table-column
              prop="address"
              :show-overflow-tooltip="true"
              align="center"
              label="正在进行的项目明细"
              width="290"
            >
              <template slot-scope="scope">
                <div class="ov">
                  <span style="margin-right:6px" v-for="item in scope.row.evaluation">{{item}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" width="200" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleCheck(scope.row)"
                  class="tableBtn"
                  style="border-color: #66C16F;color: #10981D;"
                >查看明细</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pageRow" v-if="tableData.length>0">
            <el-pagination
              @size-change="handleUserSizeChange"
              @current-change="handleUserCurrentChange"
              :current-page="currentUserPage"
              background
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="userPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="userTotal"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="业务考核" name="2">
          <assessment-statistics-module />
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      class="checkDia"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-name" style="color:#128BF1;margin-right:5px">{{checkName}}</span>
        <span class="title-age">的项目明细</span>
      </div>
      <div class="diaContainer">
        <div class="searchRow">
          <el-input class="tableSearch" v-model="searchInfo1" placeholder="标题内容搜索"></el-input>
          <div class="btnCol">
            <el-button @click="handleSearchDetails" class="search">查询</el-button>
          </div>
        </div>
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="tableData2"
          stripe
          height="33vh"
          style="width: 100%; margin-top:20px"
        >
          <el-table-column
            prop="project_name"
            :show-overflow-tooltip="true"
            align="center"
            label="项目名称"
          ></el-table-column>
          <el-table-column
            prop="pte_show"
            :show-overflow-tooltip="true"
            width="100"
            align="center"
            label="项目类型"
          ></el-table-column>
          <el-table-column
            prop="project_status_show"
            :show-overflow-tooltip="true"
            align="center"
            label="项目进度"
          ></el-table-column>
          <!-- <el-table-column prop="address" :show-overflow-tooltip="true" align="center" label="逾期项目"></el-table-column> -->
          <!-- <el-table-column prop="address" :show-overflow-tooltip="true" align="center" label="合同金额"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="outVisible"
      width="50%"
      class="outDia"
      :before-close="handleOutClose"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">导出方式</span>
      </div>
      <div class="outButton">
        <el-button @click="handleOut1">导出分表</el-button>
        <el-button @click="handleOut2">导出同一表格</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OneSelected from '../../components/OneSelected'
import AssessmentStatisticsModule from '../../components/admin/AssessmentStatisticsModule'
import fileDownload from 'js-file-download'
export default {
  data() {
    return {
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',

      showForm: '',
      activeName: '1',
      searchClass: '',
      searchInfo1: '',
      searchInfo: '',
      searchUserId: '',
      currentUserPage: 1,
      userPageSize: 10,
      userTotal: 0,
      dialogVisible: false,
      outVisible: false,
      // 新增成员
      addUserForm: {
        name: '',
        chargePeople: '',
        status: '1',
        isCharge: '1',
        isAn: '1',
        isFreeze: '1',
      },
      // 新增部门表单
      addClassForm: {
        name: '',
        chargePeople: '',
        remark: '',
      },
      // 新增部门表单
      addMessageForm: {
        name: '',
        remark: '',
      },
      tableData: [],
      tableData2: [],
      classList: [],
      searchClassArr: [],
      selectClassList: [],
      checkId: '',
      checkName: '',
    }
  },
  components: {
    OneSelected,
    AssessmentStatisticsModule,
  },
  methods: {
    handleCasSearchChange(val) {
      if (val.length > 0) {
        this.searchClass = val[val.length - 1]
      }
    },
    // // 导出文件流
    // async handleOut() {
    //   let param = new URLSearchParams()
    //   param.append('member_id', this.member_id)
    //   param.1append('token', this.token)
    //   param.append('company_id', this.company_id)
    // param.append('cache_department_id', this.cache_department_id)

    //   param.append('search', this.searchInfo)
    //   param.append('department_id', this.searchClass)
    //   param.append('to_member_id', this.searchUserId)
    //   this.$axios({
    //     method: 'post',
    //     url: '/api/Doc/project_statistics',
    //     data: param,
    //     // responseType: 'arraybuffer',
    //     responseType: 'blob',
    //   }).then((res) => {
    //     console.log(res.data)
    //     const fileName =
    //       '项目统计_' + this.parseTime(new Date(), '{y}{mm}{dd}') + '.xls'
    //     // fileDownload(res.data, fileName + '.xls')

    //     let url = window.URL.createObjectURL(new Blob([res.data])) //转换为可用URl地址

    //     let link = document.createElement('a') //创建a标签
    //     return console.log('url', url)
    //     link.style.display = 'none' //使之不可见
    //     link.href = url //赋URL地址
    //     link.setAttribute('download', fileName) //设置下载属性、以及文件名
    //     document.body.appendChild(link) //将a标签插至页面中
    //     link.click() //强制触发a标签事件
    //   })
    //   // if (res.code != 200) return this.$message.error(res.datas.msg)
    //   // this.tableData = res.datas.listInfo
    //   // this.userTotal = parseInt(res.datas.count)
    //   // console.log('文件文件文件文件', response)
    // },
    handleOutClick() {
      this.outVisible = true
    },
    // 导出分表1
    async handleOut1() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.searchInfo)
      param.append('department_id', this.searchClass)
      param.append('to_member_id', this.searchUserId)
      this.$axios({
        method: 'post',
        url: '/api/Doc/project_statistics_json',
        data: param,
        // responseType: 'arraybuffer',
        // responseType: 'blob',
      }).then((res) => {
        console.log(res.data)
        if (res.data.code != 200) return this.$message.error(res.data.datas.msg)

        const fileName =
          '项目统计_' + this.parseTime(new Date(), '{y}{mm}{dd}') + '.xls'

        let link = document.createElement('a') //创建a标签
        link.style.display = 'none' //使其隐藏
        link.href = res.data.datas.file_url //赋予文件下载地址
        link.setAttribute('download', fileName) //设置下载属性 以及文件名
        document.body.appendChild(link) //a标签插至页面中
        link.click() //强制触发a标签事件
      })
      this.outVisible = false
    },
    // 导出同一表格2
    async handleOut2() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.searchInfo)
      param.append('department_id', this.searchClass)
      param.append('to_member_id', this.searchUserId)
      this.$axios({
        method: 'post',
        url: '/api/Doc/project_statistics_indjson',
        data: param,
        // responseType: 'arraybuffer',
        // responseType: 'blob',
      }).then((res) => {
        console.log(res.data)
        if (res.data.code != 200) return this.$message.error(res.data.datas.msg)

        const fileName =
          '项目统计_' + this.parseTime(new Date(), '{y}{mm}{dd}') + '.xls'

        let link = document.createElement('a') //创建a标签
        link.style.display = 'none' //使其隐藏
        link.href = res.data.datas.file_url //赋予文件下载地址
        link.setAttribute('download', fileName) //设置下载属性 以及文件名
        document.body.appendChild(link) //a标签插至页面中
        link.click() //强制触发a标签事件
      })
      this.outVisible = false
    },
    handleSearch() {
      this.currentUserPage = 1
      this.getProjectStatisticsList()
    },
    handleSearchDetails() {
      this.getDetailList()
    },
    addUserClick() {},
    async getDetailList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('to_member_id', this.checkId)
      param.append('search', this.searchInfo1)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/project_statistics_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // this.tableData2 = res.datas.listInfo
      this.tableData2 = []
      if (res.datas.listInfo.length > 0) {
        res.datas.listInfo.forEach((item) => {
          this.tableData2.push(item)
        })
      }
      if (res.datas.listInfo2.length > 0) {
        res.datas.listInfo2.forEach((item) => {
          this.tableData2.push(item)
        })
      }
      console.log('xxxx统计列表', this.tableData2)
    },
    async handleCheck(row) {
      this.checkId = row.member_id
      this.checkName = row.nickname
      this.getDetailList()
      this.dialogVisible = true
    },
    handleClick(tab, event) {
      console.log(tab, event)
      this.syncRouteTab()
    },
    syncActiveNameFromRoute() {
      const currentTab = this.$route.query.tab
      this.activeName = currentTab === '2' ? '2' : '1'
    },
    syncRouteTab() {
      const nextTab = this.activeName === '2' ? '2' : '1'
      if (this.$route.query.tab === nextTab) return
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          tab: nextTab,
        },
      })
    },
    // Management/project_statistics
    async getProjectStatisticsList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.searchInfo)
      param.append('p', this.currentUserPage)
      param.append('p_count', this.userPageSize)
      param.append('department_id', this.searchClass)
      param.append('to_member_id', this.searchUserId)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/project_statistics',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.tableData = res.datas.listInfo
      this.userTotal = parseInt(res.datas.count)
      console.log('项目统计列表', this.projectList)
    },

    handleUserSizeChange(val) {
      this.userPageSize = val
      this.getProjectStatisticsList()
    },
    handleUserCurrentChange(val) {
      this.currentUserPage = val
      this.getProjectStatisticsList()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleOutClose(done) {
      this.outVisible = false
    },
    handleClosed() {
      this.searchInfo1 = ''
      this.tableData2 = []
      this.checkName = ''
    },
    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.searchUserId = data
    },
    // 解析时间
    parseTime(time, fm) {
      // 解析时间  time: 时间戳或者实践对象 fm: 格式 默认是{y}-{m}-{d} {h}:{i}:{s}
      if (arguments.length === 0) {
        return null
      }
      const format = fm || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a')
          return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    },
    // 获取部门列表
    async getClassList() {
      this.selectClassList = []
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('p', 1)
      param.append('p_count', 1000)
      const { data: res } = await this.$axios({
        method: 'post',
        // url: '/api/Project/project_type',
        url: '/api/Management/department',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.selectClassList = [...res.datas.listInfo]
      console.log('项目类型列表', this.selectClassList)
    },
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    this.syncActiveNameFromRoute()
    this.getClassList()
    this.getProjectStatisticsList()
  },
  watch: {
    '$route.query.tab'() {
      this.syncActiveNameFromRoute()
    },
  },
}
</script>
<style lang="less" scoped>
#organization {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .tableSearch {
        width: 20%;
        /deep/.el-input__inner {
          padding-left: 25px;
          height: 45px;
          border-radius: 24px;
          font-size: 16px;
          border: none;
          background-color: #f4f5f6;
          color: #333;
          &::placeholder {
            color: #333;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #333;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #333;
          }
        }
      }
      .btnCol {
        display: flex;
        align-items: center;
        /deep/.el-button {
          font-size: 18px;
          font-weight: normal;
          border: none;
          width: 130px;
          height: 45px;
          background: #f4a029;
          color: #fff;
          border-radius: 24px;
          padding: 0;
          margin-left: 30px;
        }
        .out {
          background: #0099ff;
        }
      }
    }
    /deep/.el-table__header {
      box-sizing: border-box;
      th {
        border-color: #40a0f2 !important;
      }
      .gutter {
        background-color: #40a0f2;
      }
    }
    // 分页行
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 表格行
    /deep/.el-table__body {
      width: 100% !important;
    }
    .el-table::before {
      display: none;
    }
    /deep/.el-table__body-wrapper {
      box-sizing: border-box;
      border: 1px solid #f4f5f6;
    }
    // 鼠标经过效果
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #eff8ff;
    }
    // 斑马颜色
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f4f5f6;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      // position: absolute;
      // bottom: 0;
      width: 6px; // 横向滚动条
      height: 5px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #ccc;
    }
    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 20px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #999999;
      font-weight: 400;
      padding-right: 180px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #333 !important;
    }
    /deep/.el-tabs__item:hover {
      color: #333 !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }
  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // 修改查看diapadding

  /deep/.checkDia {
    .el-dialog__body {
      width: 100%;
      box-sizing: border-box;
      padding: 40px 6%;
    }
  }
  // dialog弹窗
  /deep/.el-dialog {
    .el-input__inner {
      height: 45px;
      border-radius: 24px;
      font-size: 16px;
      border: none;
      background-color: #f4f5f6;
    }
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }
  // 搜索行
  .searchRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    /deep/.tableSearch {
      width: 50%;
      /deep/.el-input__inner {
        text-align: center;
        height: 48px;
        border-radius: 24px;
        font-size: 16px;
        border: none;
        background-color: #f4f5f6;
      }
    }
    .btnCol {
      display: flex;
      align-items: center;
      /deep/.el-button {
        font-size: 20px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 48px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 20px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 56px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    /deep/.el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: 18px;
      }
    }
    .el-input__inner {
      font-size: 18px;
      width: 80%;
      height: 56px;
      border-radius: 0;
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 250px;
        font-size: 18px;
        resize: none;
        border-radius: 0;
      }
    }
    .el-radio-group {
      height: 56px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: 15%;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 18px;
      }
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  .ov {
    width: 100%;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*不换行*/
    text-overflow: ellipsis; /*超出部分文字以...显示*/
  }
}
// 修改人员选择(搜索栏的人员选择)
/deep/#MyTransfer {
  width: 20%;
  .filter-dash-btn {
    border: none;
    border-radius: 24px;
    background-color: #f4f5f6;
    height: 45px;
    font-size: 16px;
    color: #333;
    .filter-tips-default {
      color: #333;
    }
  }
  .checked-app-item {
    margin-left: 10px;
    border: none;
    background-color: #f4f5f6;
  }
}
.outButton {
  display: flex;
  justify-content: space-around;
}
.outDia {
  margin-top: 20vh;
}

/deep/#MyTransfer {
  .filter-dash-btn {
    width: 100%;

    .filter-tips-default {
      width: 100%;
      padding-left: 25px;
    }
  }
}
</style>
